// InitialState.js
// Holder for default state

// Class Definition
class InitialState {
  static GetClients = () => {
    return [
      "Andradas",
      "Angú do Gomes",
      "Arte Café",
      "Arte Pastel",
      "Assist",
      "B. Rio",
      "Belga",
      "Bistrô",
      "Bistrô II",
      "Boca Boca",
      "Brotinho",
      "C. Bolo",
      "C. Bolo BOTAFOGO",
      "Caçarola",
      "Campeão",
      "Canadela",
      "Canibal",
      "Casa de Bolo COPA",
      "Casarão",
      "Castelo Gourmet",
      "Castelograma",
      "Catete",
      "Centenário",
      "Coliseu",
      "Da Lapa",
      "Delícias do Porto",
      "Domino's",
      "Eletrobrás",
      "Evaristo",
      "Fábrica de Bolo",
      "Feijão",
      "Fim de Tarde",
      "Florianus",
      "G. Bicão",
      "Guanabara",
      "Gutas",
      "Imaculada",
      "Imperatriz",
      "Le Doux",
      "Le Gouth",
      "Linox",
      "Malaga",
      "Marrecas",
      "Minimix",
      "Nitgrama",
      "Passos",
      "Pistache",
      "Pomodoro",
      "Província",
      "Província Botaf.",
      "R. Jordão",
      "Razzi",
      "Real Time",
      "Rio Park",
      "Royal",
      "RS",
      "S. Cidade",
      "S. Pena",
      "Sacabral",
      "Sacadura Fit",
      "Sen. Pompeu",
      "Senado",
      "Sindicato Churras",
      "Sobrado",
      "Sucomania",
      "T. Carioca",
      "Tijuca",
      "Tratoria",
      "Velho Sonho",
      "Verdinho",
      "Vó Alzira",
      "Zagatti",
      "Zai Tune"
    ];
  };

  static GetProducts = () => {
    return [
      "Abacate",
      "Abacaxi",
      "Abóbora",
      "Abobrinha",
      "Acelga",
      "Agrião",
      "Aipim",
      "Aipo",
      "Alecrim",
      "Alface Americana",
      "Alface Crespa",
      "Alface Lisa",
      "Alface Roxa",
      "Alho",
      "Alho Poró",
      "Banana da Terra",
      "Banana D'água",
      "Banana Prata",
      "Barôa",
      "Batata",
      "Batata doce",
      "Berinjela",
      "Bertalha",
      "Beterraba",
      "Brócolis",
      "Bruxelas",
      "Calabresa",
      "Cebola",
      "Cebolinha",
      "Cenoura",
      "Chicória",
      "Chuchu",
      "Coco",
      "Coentro",
      "Couve",
      "Couve Flor",
      "Dedo de Moça",
      "Ervilha",
      "Espinafre",
      "Frisée",
      "Gengibre",
      "Goiaba",
      "Hortelã",
      "Inhame",
      "Jiló",
      "Kiwi",
      "Laranja",
      "Limão",
      "Louro",
      "Maçã",
      "Mamão",
      "Manga",
      "Manjericão",
      "Maracujá",
      "Maxixe",
      "Melancia",
      "Melão",
      "Milho",
      "Morango",
      "Moyashe",
      "Nabo",
      "Orange",
      "Ovos",
      "Papaya",
      "Pepino",
      "Pêra",
      "Pêssego",
      "Pimentão",
      "Pimentão Amarelo",
      "Pimentão Vermelho",
      "Pokan",
      "Quiabo",
      "Rabanete",
      "Radiccio",
      "Repolho",
      "Repolho Roxo",
      "Rúcula",
      "Salsa",
      "Salsa Crespa",
      "Salvia",
      "Tomate",
      "Tomate Cereja",
      "Tomilho",
      "Uva",
      "Vagem",
    ];
  };
}

// Default Export
export default InitialState;


// WEBPACK FOOTER //
// ./src/data/InitialState.js